import { render, staticRenderFns } from "./light1.vue?vue&type=template&id=3abcd025&scoped=true"
import script from "./light1.vue?vue&type=script&lang=js"
export * from "./light1.vue?vue&type=script&lang=js"
import style0 from "./light1.vue?vue&type=style&index=0&id=3abcd025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abcd025",
  null
  
)

export default component.exports